import * as Yup from "yup";
import MESSAGE from "~/utils/messages";

export const schema = Yup.object().shape({
  Email: Yup.string()
    .matches(
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/g,
      MESSAGE.invalidMail
    )
    .required(MESSAGE.requiredField),
  Senha: Yup.string()
    .matches(
      // eslint-disable-next-line
      /^(?=.*\d)[A-Za-z0-9 _!@#$%^&*()~+`\-=\[\]{};':"\\|,.<>\/?]*$/,
      MESSAGE.passwordMatch
    )
    .min(8, MESSAGE.passwordMatch)
    .max(12, MESSAGE.passwordMatch)
    .required(MESSAGE.requiredField),
});
